import { useCallback } from "react";

import { useAssetUploader } from "@skilitics/assets";

import type { ThumbnailAssetValue } from "./NodeTemplateForm.tsx";

export const useGetThumbnailAssetId = () => {
  const uploader = useAssetUploader();
  return useCallback(
    async (thumbnailAsset: ThumbnailAssetValue | undefined) => {
      if (!thumbnailAsset) {
        return undefined;
      }
      if (thumbnailAsset.source === "file") {
        return thumbnailAsset.assetId;
      } else {
        const asset = await uploader.receiveFile(thumbnailAsset.file);
        return asset.assetId;
      }
    },
    [uploader],
  );
};
